import { FC, useContext, useState } from 'react';
import { Box, Collapse, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BasicExpand from '../common/BasicExpand';
import { CampaignContext } from '../../contexts/CampaignContext';

type IRejectedCampaignExpand = {};

const RejectedCampaignExpand: FC<IRejectedCampaignExpand> = () => {
	const [expanded, setExpanded] = useState(false);

	const { fetchedCampaign } = useContext(CampaignContext);

	const { reject_reason, reject_title } = fetchedCampaign!;

	const { t } = useTranslation();

	const handleExpand = () => {
		setExpanded(prev => !prev);
	};

	return (
		<Box className={`${expanded && 'mb-0 pb-8'}`}>
			<BasicExpand title={t('campaign-rejection-reason')} expanded={expanded} onExpand={handleExpand} />
			<Collapse in={expanded} className={`rounded-b-lg bg-background-paper px-6 pt-6 ${expanded && 'pb-6'} `}>
				<TextField disabled fullWidth variant="filled" label={t('ad-rejection-reason')} defaultValue={reject_title} />
				<TextField disabled className="mt-6" fullWidth variant="filled" id="filled-multiline-static" label={t('description')} multiline rows={4} value={reject_reason} />
			</Collapse>
		</Box>
	);
};

export default RejectedCampaignExpand;
